import api from '../../services/api';
import axios from 'axios'
import Cookies from 'universal-cookie'
import { getConsultantIdentifier } from '../consultantUtils';
import ErrorService from '../../services/errorService';
import Swal from 'sweetalert2';
import { DocumentScannerOutlined } from '@mui/icons-material';
import html2pdf from 'html2pdf.js';
import { saveAs } from 'file-saver';

const data = {
    Entrevista: {/*id:222, contractId: 5989, clientId: 68, payingId: 70*/ },
    hojaAtencion: {},
    Defendido: {},
    servicios: {},
    Acreedores: {},
    Causas: {},
    Cuotas: {},
    Pagador: {},
    contrato: [],
    validacion: {},
    Documento: {},
    Consentimiento: {},
    TareasCausa: {},
    TareasValidacion: {},
    Actualizacion: {},
    ContratoCancelado: {} ,
    ContratoFiniquitado: {} ,
    ContratoFirmado: {},
    Legal: {},
    ContratoActualizacion: {},
    Tribunales: [],
    Grupos : []
};
const initialState = data;

const _endpoints = {
    Entrevista: { get: "/V2/", post: "/V2/Create", put: "/V2/GuardarOrigen", patch: "/V2/UpdateHojaAtencion", delete: "" },
    // hojaAtencion: { get: "",  patch: "" },
    Defendido: { get: "/V2/", post: "/V2/updateClient", put: "", patch: "", delete: "" },
    //servicios: { get: "", post: "", put: "", patch: "", delete: "" },
    //acreedores: { get: "", post: "", put: "", patch: "", delete: "" },
    Causas: { get: "/V2/", post: "/V2", put: "/V2/guardarTareasCausa", patch: "/V2", delete: "/V2" },
    Cuotas: { get: "/V2/", post: "/V2/guardarCuotas", put: "", patch: "", delete: "" },
    Pagador: { get: "/V2/", post: "/V2/guardarPagador", put: "", patch: "", delete: "" },
    contrato: { get: "/V2/serviciosyacreedores/", post: "/V2/UpdateServiciosYAcreedores", put: "", patch: "/V2/DeleteAcreedorContratado", delete: "/V2/DeleteServicioContratado" },
    validacion: { get: "", post: "", put: "", patch: "", delete: "" },
    Documento: { get: "/V2/contratoHtml/", post: "/V2/SaveHtmlContrat", put: "", patch: "", delete: "" },
    desbloquear: { get: "", post: "", put: "", patch: "", delete: "" },
    Acreedores: { get: "/V2/AcreedoresSistema", post: "", put: "", patch: "", delete: "" },
    TareasCausa: { get: "/V2/", post: "", put: "", patch: "", delete: "" },
    TareasValidacion: { get: "/V2/", post: "/V2/saveTasksList", put: "", patch: "", delete: "" },
    Consentimiento: { get: "/V2/", post: "", put: "", patch: "", delete: "" },
    Actualizacion: { get: "/V2/", post: "/V2/IniciarActualizacion", put: "/V2/guardarModelo", patch: "/V2/EjecutarActualizacion", delete: "/V2/AnularActualizacion" },
    ContratoCancelado: { get: "/V2/" , post: "/V2/Cancelar" },
    ContratoFiniquitado: { get: "/V2/" },
    ContratoFirmado: { get: "/V2/" },
    Legal: { post: "/V2", put:'/V2' },
    ContratoValidado: { get: "/V2/" },
    ContratoActualizacion: { get: "/V2/", post: "/V2/firma", put: "/V2/enviarAutorizacion", patch: "/V2/modificarTemplate", delete: "" },
    Download: {post: "/V2"},
    Tareas: {get: "/V2/"},
    Tribunales: {get: "/V2"},
    Grupos: {get: "/V2"},
}



export default function contratoReducer(state = data, action) {
    switch (action.type) {
        case 'RESET':
            return initialState;
        case 'SET_FIELD':
            return { ...state, [action.key]: action.payload };
        default:
            return state;
    }
};


export const setCargaDatos = (actionKey, method, data) => async (dispatch, getState) => {
    const consultantIdentifier = getConsultantIdentifier()
    if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
    }
    return await dispatch(setFetch(actionKey, method, _endpoints[actionKey]?.[method], data, consultantIdentifier))
}

export const setCrearHojaEntrevista = (actionKey, method, data) => async (dispatch, getState) => {

    const consultantIdentifier = getConsultantIdentifier()
    if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
    }
    console.log('_endpoints[actionKey]?.[method] ' + _endpoints[actionKey]?.[method]);

    return await dispatch(setFetch(actionKey, method, _endpoints[actionKey]?.[method], data, consultantIdentifier))
}

const setFetch = (key, method, endpoint, data, consultantIdentifier) => async (dispatch) => {
    const cookies = new Cookies()
    const headers = { 'Authorization': `Bearer ${cookies.get('tokenGcc')}` }

    data = data ?? ""
    const id = !isNaN(Number(data)) ? data : ""
    const url = `${window.REACT_APP_GGC_API}/api/${key}${endpoint}${id}`
    var response = null;
    if (method != "get" && key != "ContratoCancelado") data.CreateBy = consultantIdentifier

    try {
        /* METODOS */
        switch (method) {
            case "get":
                response = await ErrorService.withTimeout(api.get(`${url}`, { headers }))
                break
            case "post":
                response = await ErrorService.withTimeout(api.post(url, data, { headers }))
                break
            case "put":
                response = await ErrorService.withTimeout(api.put(url, data, { headers }))
                break
            case "patch":
                response = await ErrorService.withTimeout(api.patch(url, data, { headers }))
                break
            case "delete":
                const deleteUrl = `${window.REACT_APP_GGC_API}/api/${key}${endpoint}`;
                response = await ErrorService.withTimeout(api.delete(deleteUrl, { headers, data }));
                break;
        }

        if (response) {
            if (response.status >= 200 && response.status < 300) {
                if(key=="Download"){
                    alertRedux("success", response.data.message)
                    return {document:response.data.document, fileName:response.data.fileName};
                }
                dispatch({ type: 'SET_FIELD', key, payload: response.data })
                if (method != 'get'){
                    alertRedux("success", response.data.message)
                }
                if(key=="Tareas" && method=="get")
                    return response.data
                return true;
            }
        }
        else
            alertRedux("danger", "Problema no identificado, al intentar conecetar con el servidor")

    } catch (error) {
        console.log(error)
        
        if (error.response?.status == 404 && key =="Download") {
            alertRedux("warning", error.response?.data.message ?? "Documento no disponible")
        }
        else if (error.response?.status == 404) {
            alertRedux("warning", "ruta no encontrada, comuniquese con el proveedor")
        }
        else if (error.response?.status == 403) {
            const errorMessage = error.response?.data?.message || "Usted no está autorizado para realizar esta acción.";
            alertRedux("warning", errorMessage);
        }
    }
    return false;

}


const alertRedux = (type, message) => {
    Swal.fire({
        title: message,
        icon: type,
        confirmButtonText: 'Entendido'
    });
};


// Declaración fuera de cualquier función
export const resetAction = () => async (dispatch, getState) =>
    dispatch({ type: 'RESET', payload: null });
